import { compileDashboardFeature, DashboardComponentType } from '@/features/dashboard'
import { FormatOptions } from '@/components/AnalyticsDashboard/formatter'
import { EntityLevel } from '@/composables/useEntityLevel'

const enabledEntityLevels: EntityLevel[] = ['REGION', 'COMPLEX', 'REAL_ESTATE']

const format: FormatOptions = {
  format: {
    type: 'intl-number',
    maximumFractionDigits: 0
  }
}

export const buildingScore2 = compileDashboardFeature({
  name: 'building-score',
  title: {
    en: 'Building score',
    sv: 'Building score'
  },
  dataSectionTitle: {
    en: 'Building score',
    sv: 'Building score'
  },
  icon: 'IconAward',
  enabled: true,
  defaultFilters: {
    calendar: {
      quickSelect: 'last30days'
    },
    onlyBusinessHours: false,
    defaultDateSelection: 'last5years',
    dateSelections: ['last5years']
  },
  measurements: [
    {
      name: 'building_score',
      field: {
        name: 'attractiveness_avg',
        expression: {
          type: 'avg',
          exp: {
            type: 'field',
            name: 'attractiveness'
          }
        }
      },
      title: {
        sv: 'Attraktivitet',
        en: 'Attractiveness'
      },
      options: {
        color: '#40A9FF',
        enabledEntityLevels,
        format
      }
    },
    {
      name: 'building_score',
      field: {
        name: 'condition_avg',
        expression: {
          type: 'avg',
          exp: {
            type: 'field',
            name: 'condition'
          }
        }
      },
      title: {
        en: 'Condition',
        sv: 'Skick'
      },
      options: {
        color: '#36CFC9',
        enabledEntityLevels,
        format
      }
    },
    {
      name: 'building_score',
      field: {
        name: 'area_avg',
        expression: {
          type: 'avg',
          exp: {
            type: 'field',
            name: 'area'
          }
        }
      },
      title: {
        en: 'Area',
        sv: 'Area'
      },
      options: {
        color: '#FAD337',
        enabledEntityLevels,
        format
      }
    }
  ],
  components: [
    {
      type: DashboardComponentType.Kpi,
      name: 'attrativeness-kpi',
      measurement: 'building_score.attractiveness_avg',
      info: {
        sv: 'Attraktivitet',
        en: 'Attractiveness'
      }
    },
    {
      type: DashboardComponentType.Kpi,
      name: 'condition-kpi',
      measurement: 'building_score.condition_avg',
      info: {
        sv: 'Skick',
        en: 'Condition'
      }
    },
    {
      type: DashboardComponentType.Kpi,
      name: 'area-kpi',
      measurement: 'building_score.area_avg',
      info: {
        sv: 'Area',
        en: 'Area'
      }
    },
    {
      type: DashboardComponentType.TimeSeries,
      name: 'attrativeness-time-series',
      measurements: ['building_score.attractiveness_avg', 'building_score.condition_avg'],
      title: {
        sv: 'Attraktivitet',
        en: 'Attractiveness'
      },
      info: {
        sv: 'Attraktivitet',
        en: 'Attractiveness'
      }
    }
  ]
})
